export default {
  apiPre: '/api',
  resPre: 'http://hainayunsd.oss-cn-qingdao.aliyuncs.com',
  tokenKey: 'hainaUserToken',
  accountKey: 'accountInfo'
}
